module.exports = __webpack_public_path__ + "img/no-data-internet.ac6b4223.svg";